module.exports = __webpack_public_path__ + "img/image19.254e28f6.png";